<template>
    <div class="content" ref="echarts"></div>
</template>

<script>
// 引入echarts
import * as echarts from "echarts";

// ★ 如果你之前用的是 v4 写法，可以去掉这行旧地图引用
//   import 'echarts/lib/chart/map'
//   import 'echarts/map/js/china.js'

// ★ 引入广东省 geoJSON（路径按实际调整）
import guangdongJson from "echarts/map/json/province/guangdong.json";

export default {
    data() {
        return {};
    },

    mounted() {
        this.init();
    },

    methods: {
        init() {
            // 注册广东地图
            echarts.registerMap("guangdong", guangdongJson);

            const myChart = echarts.init(this.$refs.echarts);

            // 这里只保留广东内需要展示的城市
            const guangdongGeoCoordMap = {
                广州: [113.264385, 23.129112],
                深圳: [114.057868, 22.543099],
                珠海: [113.576726, 22.270715],
                佛山: [113.121416, 23.021548],
                东莞: [113.746262, 23.046237],
                中山: [113.392782, 22.517646],
            };

            // 散点数据（城市点）
            const chinaDatas = [];
            const mapObject = { name: "", value: null };
            for (const key in guangdongGeoCoordMap) {
                mapObject.name = key;
                mapObject.value = guangdongGeoCoordMap[key];
                chinaDatas.push(JSON.parse(JSON.stringify(mapObject)));
            }

            // 飞线数据：从深圳到珠海的“飞机头”
            const flyLines = [
                {
                    coords: [
                        guangdongGeoCoordMap["深圳"],
                        guangdongGeoCoordMap["珠海"],
                    ],
                },
            ];

            const option = {
                geo: {
                    map: "guangdong",
                    show: true,
                    roam: true,
                    top: "20px",
                    label: {
                        emphasis: { show: false },
                    },
                    itemStyle: {
                        normal: {
                            areaColor: "#09184F",
                            borderColor: "#00ffff",
                            shadowColor: "#09184F",
                            shadowBlur: 20,
                        },
                    },
                    // ★ 预留：动态高亮的多个区域
                    regions: [],
                },
                series: [
                    // 散点
                    {
                        type: "effectScatter",
                        coordinateSystem: "geo",
                        data: chinaDatas,
                        showEffectOn: "render",
                        rippleEffect: {
                            scale: 4,
                            brushType: "stroke",
                        },
                        hoverAnimation: true,
                        label: {
                            normal: {
                                show: true,
                                formatter: "{b}",
                                position: "right",
                                fontWeight: 500,
                                fontSize: 14,
                            },
                        },
                        itemStyle: {
                            normal: {
                                color: "#00e3ff",
                                shadowBlur: 10,
                                shadowColor: "#333",
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                color: "#f4e925",
                            },
                        },
                        zlevel: 1,
                    },
                    // 原有线（如果不需要可以删除）
                    // {
                    //   type: 'lines',
                    //   coordinateSystem: 'geo',
                    //   zlevel: 1,
                    //   effect: {
                    //     show: true, period: 5, trailLength: 0, symbol: 'arrow', color: '#01AAED', symbolSize: 8,
                    //   },
                    //   lineStyle: {
                    //     normal: {width: 1.2, opacity: 0.6, curveness: 0.2, color: '#FFB800'}
                    //   },
                    //   data: [] // 这里留空或按需填
                    // },

                    // ★ 新增：深圳 → 珠海 飞机头
                    {
                        type: "lines",
                        coordinateSystem: "geo",
                        zlevel: 2,
                        effect: {
                            show: true,
                            period: 4, // 飞机速度
                            trailLength: 0.2, // 尾迹长度
                            symbol: "plane", // 飞机头（部分版本需要自定义 path，可替换为 'arrow'）
                            symbolSize: 12,
                            color: "#01AAED",
                        },
                        lineStyle: {
                            normal: {
                                width: 2,
                                opacity: 0.8,
                                curveness: 0.2,
                                color: "#FFB800",
                            },
                        },
                        data: flyLines,
                    },
                ],
            };

            myChart.setOption(option);
            this.myChart = myChart;
            this.highlightRegions(["深圳市", "珠海市"]);
            // window.addEventListener('resize', () => myChart.resize())
        },
        highlightRegions(names = []) {
            if (!this.myChart) return;

            const regions = names.map((name) => ({
                name, // 必须和 geoJSON 中 properties.name 一致
                itemStyle: {
                    areaColor: "#ff8800",
                    borderColor: "#ffffff",
                    shadowColor: "#ff8800",
                    shadowBlur: 20,
                },
                label: {
                    show: true,
                    color: "#fff",
                    fontWeight: "bold",
                },
            }));

            this.myChart.setOption(
                {
                    geo: {
                        regions,
                    },
                },
                false // 不全量更新，只 merge
            );
        },
    },
};
</script>

<style scoped>
.content {
    width: 100%;
    height: 100%;
}
</style>
